import { RefObject, useEffect, useMemo, useState } from 'react';

export const useIsInViewport = (ref: RefObject<HTMLDivElement>): boolean => {
    const [isIntersecting, setIsIntersecting] = useState<boolean>(false);

    const observer = useMemo(
        () =>
            new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting), {
                // Trigger when at least 50% of the element is visible
                threshold: 0.5,
                // Consider element visible if it's within 100px of viewport
                rootMargin: '100px 0px',
            }),
        []
    );

    useEffect(() => {
        const element = ref?.current;
        if (element) {
            observer.observe(element);
        }

        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [ref, observer]);

    return isIntersecting;
};
